import { render } from "./Labdescriptivestats.vue?vue&type=template&id=1f0235dc&scoped=true"
import script from "./Labdescriptivestats.js?vue&type=script&lang=js"
export * from "./Labdescriptivestats.js?vue&type=script&lang=js"

import "./Labdescriptivestats.vue?vue&type=style&index=0&id=1f0235dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0235dc"]])

export default __exports__